export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/construction-6cff760f0f084fd25e9bb71e4da21030.svg";